/* OROS Design — Configurator JS */
(function () {
  'use strict';

  var colorBtns = document.querySelectorAll('.config-color-btn');
  var luneBtns  = document.querySelectorAll('.config-lune-btn');
  var configImg = document.getElementById('config-img');
  var summaryLabel = document.getElementById('config-summary-label');
  var totalEl   = document.getElementById('config-total');
  var klarnaEl  = document.getElementById('config-klarna');
  var luneLine  = document.getElementById('config-lune-line');
  var luneLabel = document.getElementById('config-lune-label');
  var addCartBtn = document.getElementById('config-add-cart');
  var discountLine = document.getElementById('config-discount-line');

  var state = {
    color: 'noir',
    colorPrice: 4799,
    luneColor: 'none',
    lunePrice: 0
  };

  var colorNames = {
    gris: 'Béton naturel',
    noir: 'Noir minéral'
  };

  var luneNames = {
    gris: 'Béton naturel',
    noir: 'Noir minéral'
  };

  function formatPrice(n) {
    var s = n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return s + ' $';
  }

  function formatKlarna(n) {
    var q = n / 4;
    var intPart = Math.floor(q);
    var decPart = Math.round((q - intPart) * 100);
    var dec = decPart < 10 ? '0' + decPart : '' + decPart;
    var formatted = intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0');
    return '4 \u00d7 ' + formatted + ',' + dec + ' $';
  }

  function updateUI() {
    var discount = (state.luneColor !== 'none' && state.lunePrice > 0) ? 500 : 0;
    var total = state.colorPrice + state.lunePrice - discount;

    if (discountLine) {
      if (discount > 0) {
        discountLine.classList.remove('hidden');
      } else {
        discountLine.classList.add('hidden');
      }
    }

    if (summaryLabel) {
      summaryLabel.textContent = 'Foyer OROS — ' + (colorNames[state.color] || state.color);
    }

    if (luneLine && luneLabel) {
      if (state.luneColor !== 'none' && state.lunePrice > 0) {
        luneLine.classList.remove('hidden');
        luneLabel.textContent = luneNames[state.luneColor] || state.luneColor;
      } else {
        luneLine.classList.add('hidden');
      }
    }

    if (totalEl) totalEl.innerHTML = formatPrice(total);
    if (klarnaEl) klarnaEl.textContent = formatKlarna(total);

    // Update image
    if (configImg) {
      var src = configImg.getAttribute('data-' + state.color);
      if (src) {
        configImg.style.opacity = '0';
        setTimeout(function () {
          configImg.src = src;
          configImg.alt = 'Foyer OROS ' + (colorNames[state.color] || state.color);
          configImg.style.opacity = '1';
        }, 150);
      }
    }
  }

  // Color buttons
  colorBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      colorBtns.forEach(function (b) {
        b.classList.remove('border-primary', 'bg-primary/5');
        b.classList.add('border-white/10');
        b.setAttribute('aria-pressed', 'false');
        var ch = b.querySelector('.config-check');
        if (ch) { ch.classList.add('hidden'); ch.classList.remove('flex'); }
      });
      btn.classList.remove('border-white/10');
      btn.classList.add('border-primary', 'bg-primary/5');
      btn.setAttribute('aria-pressed', 'true');
      var ck = btn.querySelector('.config-check');
      if (ck) { ck.classList.remove('hidden'); ck.classList.add('flex'); }

      state.color = btn.dataset.color;
      state.colorPrice = parseInt(btn.dataset.price, 10) || 0;
      updateUI();
    });
  });

  // Demi-Lune buttons
  luneBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      luneBtns.forEach(function (b) {
        b.classList.remove('border-primary', 'bg-primary/5');
        b.classList.add('border-white/10');
        b.setAttribute('aria-pressed', 'false');
        var ch = b.querySelector('.config-check');
        if (ch) { ch.classList.add('hidden'); ch.classList.remove('flex'); }
      });
      btn.classList.remove('border-white/10');
      btn.classList.add('border-primary', 'bg-primary/5');
      btn.setAttribute('aria-pressed', 'true');
      var ck = btn.querySelector('.config-check');
      if (ck) { ck.classList.remove('hidden'); ck.classList.add('flex'); }

      state.luneColor = btn.dataset.lune;
      state.lunePrice = parseInt(btn.dataset.lunePrice, 10) || 0;
      updateUI();
    });
  });

  // Add to Cart
  if (addCartBtn) {
    addCartBtn.addEventListener('click', function () {
      var variants = window.orosVariants || { foyer: {}, lune: {} };
      var foyerVariant = variants.foyer[state.color];
      var luneVariant = (state.luneColor !== 'none') ? variants.lune[state.luneColor] : null;

      if (!foyerVariant) {
        alert('Produit non disponible. Contactez info@orosdesign.ca');
        return;
      }

      var items = [{ id: foyerVariant, quantity: 1 }];
      if (luneVariant) {
        items.push({ id: luneVariant, quantity: 1 });
      }

      addCartBtn.disabled = true;
      addCartBtn.textContent = 'Ajout en cours…';

      // Clear cart first, then add items
      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function () { return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }); })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart error');
        return res.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        addCartBtn.disabled = false;
        addCartBtn.textContent = 'Débutez votre expérience OROS';
        alert('Une erreur est survenue. Réessayez ou contactez info@orosdesign.ca');
      });
    });
  }

})();
